import { Link, useHistory } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Edit, OpenInBrowser, Psychology } from "@mui/icons-material";
import DeletPatient from "components/table/Patient/DeletPatient";
import { PatientAccountType } from "app/types";

import "./style.scss";

type ActionButtonsProps = {
  patient: PatientAccountType;
  setOpenedOptionsPatient: (open: boolean) => void;
};

const ActionButtons = ({
  patient,
  setOpenedOptionsPatient,
}: ActionButtonsProps) => {
  const history = useHistory();

  const handleEditPatient = (
    event: React.MouseEvent<HTMLElement>,
    patient: PatientAccountType,
  ) => {
    event.stopPropagation();
    setOpenedOptionsPatient(true);
    history.push({
      pathname: `/admin/account/edit/${patient.accountId}`,
      state: { data: patient },
    });
  };

  return (
    <div className="patient-action-buttons">
      <DeletPatient
        item={patient}
        setOpenedOptionsPatient={setOpenedOptionsPatient}
      />
      <div
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          handleEditPatient(event, patient)
        }
        // to={{
        //   pathname: `/admin/account/edit/${patient.accountId}`,
        //   state: { data: patient },
        // }}
        title="Editar"
      >
        <IconButton aria-label="upload picture" component="label" size="small">
          <Edit fontSize="inherit" />
        </IconButton>
      </div>
      <Link
        to={`/admin/account/results/${patient.accountId}`}
        title="Resultados"
      >
        <IconButton aria-label="upload picture" component="label" size="small">
          <OpenInBrowser fontSize="inherit" />
        </IconButton>
      </Link>
    </div>
  );
};

export default ActionButtons;
